module.exports = __webpack_public_path__ + "static/media/btn-appstore.5ec63382.png";